import { useState } from 'react';
import header from './assets/travel.jpg';
import weddingVideo from './assets/WED VID.mp4';
import proposal from './assets/proposal.JPG';
import './App.css';
import Parallaximg from './components/Parallaximg';
import RSVPButton from './components/RSVP/button';
import RSVP from './components/RSVP/form';
import SlideInWrapper from './components/SlideInWrapper';
import ParallaxWrapper from './components/ParallaxWrapper';
import Swiper from './components/Swiper/Swiper';
import PicDivider from './components/PicDivider';
import './index.css';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import NavContainer from './components/NavContainer';


function App() {
  const [isRSVPOpen, setRSVP] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showRSVPOnMenu, setShowRSVPOnMenu] = useState(window.innerWidth >999);
  gsap.registerPlugin(ScrollToPlugin);

const overlayStyle = {
  position: "absolute",

  left: 0,
  width: "100%",
  height: "auto",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
  color: "#fff",
  fontSize: "2rem",
  fontWeight: "bold",
  textShadow: "0 2px 8px rgba(0,0,0,0.7)",
  gap: "1rem",
};
const scrollToSection = (id) => {
  gsap.to(window, {
    duration: 1,
    scrollTo: {
      y: `#${id}`,
      offsetY: 100, // height of sticky nav
    },
    ease: 'power2.out',
  });
};

  return (
  
    <div className="app">
      { isRSVPOpen && <RSVP isOpened={isRSVPOpen} setState={setRSVP}/>}
  <section className='hero'>
    
     <div className='video-container'>
      <video
        src={weddingVideo}
        autoPlay
        loop
        muted
        playsInline
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: 0,
        }}
      />
   </div>
 
   
   <ParallaxWrapper style={overlayStyle} className='overlayText'>

      <SlideInWrapper duration={5}><p style={{fontSize: "clamp(2rem, 7vw, 20px)", fontFamily: "PP Neue Montreal", }}>25.07.2026</p></SlideInWrapper>
       <SlideInWrapper duration={5} ><p style={{fontSize: "clamp(2rem, 7vw, 70px)", fontFamily: "PP Neue Montreal", letterSpacing: "0.2em"}}>BENJAMIN & MARA</p></SlideInWrapper>
      <SlideInWrapper duration={5}><p style={{fontSize: "clamp(2rem, 7vw, 70px)", fontFamily: "Italianno, cursive",  fontWeight: 400,fontStyle: "normal"}}>Dar Es Salaam, Tanzania</p></SlideInWrapper>
     {  !showRSVPOnMenu && <p style={{marginRight: '1rem'}}><RSVPButton onClick={setRSVP}/></p>}
     </ParallaxWrapper>
 <NavContainer menuOpen={menuOpen} setMenuOpen={setMenuOpen} scrollToSection={scrollToSection} showRSVPOnMenu={showRSVPOnMenu} setRSVP={setRSVP}/>


  </section>
    <section id="story" className='about'>
        <div className="col " >
          <Parallaximg src={proposal} />
         
        </div>
        <div className="col" style={{display:"block", position:"relative", background:"black"}}>
            <h1>Join us as we embark on a
          journey of love, joy and 
            eternal happiness.</h1>
         
<p>We met in college and quickly realized that what we had was something truly special.
Since our first date on February 28, 2019, our love has grown stronger with every passing year.
On July 14, 2025, under the Parisian fireworks of Bastille Day, we began our forever together with a proposal we’ll never forget.
Now, we can’t wait to celebrate the next chapter of our love story with you.</p>

   <p><RSVPButton onClick={setRSVP} label="Confirm your Presence"/></p>
     </div>
        {/* <div className="col">
          <Parallaximg src={proposal}/>
        </div> */}
       </section> 
       <section id="travel" className='about'>
        
        <div className="col" style={{position:"relative", background:"black", zIndex:1001}}>
          <h1>
            Travel & Stay In{' '}
          </h1>
          <span style={{fontFamily: "Italianno, cursive", fontSize: "clamp(2rem, 7vw, 70px)", color: "#dbccc0", fontWeight: 400, fontStyle: "normal"}}>Dar Es Salaam, Tanzania</span>

          <h2>Visa</h2>
          <p>Visas can be acquired upon arrival for 50 USD for most nationalities, while US citizens are required to pay 100 USD for a multiple-entry visa.You will be able to pay cash(USD) or card If you prefer to arrange yours in advance, you can apply online using a Visa card through <a target="_blank" rel="noopener noreferrer" href="https://visa.immigration.go.tz/">the official Tanzania eVisa portal</a>.</p>
          <h2>Stay</h2>
          <p>For your stay, we highly recommend the <a target="_blank" rel="noopener noreferrer" href="https://www.hyatt.com/hyatt-regency/en-US/darhr-hyatt-regency-dar-es-salaam-the-kilimanjaro">Hyatt Regency Dar es Salaam, The Kilimanjaro</a>. If you’d prefer to explore other options, the Johari Rotana, Dar es Salaam Serena Hotel, and Four Points by Sheraton New Africa are excellent alternatives situated nearby.</p>
          <h2>Food & Transportation </h2>
          <p>While Dar Es Salaam hotels do not offer all-inclusive packages, we will be providing gatherings for breakfast, lunch, and dinner, along with transportation throughout the wedding festivities.</p>
          
        </div>
     
       <div className="col">
        <Parallaximg src={header} />
      </div>  
 </section>
      <PicDivider/>
      
        
     <section id="itinerary" className='itinerary'>
      <Swiper/>
       <p><RSVPButton onClick={setRSVP}/></p>
     </section>
    </div> 
  );
}

export default App;
